import { useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useLocation } from 'react-router-dom';

import { KeyboardShortcutsSidePane } from '@/Pages/KeyboardShortcutsSidePane';
import CommandKeyIcon from '@/icons/CommandKeyIcon.svg?react';

import { NavLink } from '../NavSidebar/NavLink';

function KeyboardShortcutLink(props: {
  expanded: boolean;
  className?: string;
}) {
  const loc = useLocation();
  const [
    isKeyboardShortcutDocumentationOpen,
    setIsKeyboardShortcutDocumentationOpen,
  ] = useState(false);

  useHotkeys('meta+/', () => setIsKeyboardShortcutDocumentationOpen(true), {
    enableOnContentEditable: true,
  });

  const showCurrentLocationShortcuts = () => {
    setIsKeyboardShortcutDocumentationOpen(true);
  };

  return (
    <>
      <NavLink
        key={'shortcuts'}
        location={loc}
        label={'Keyboard Shortcuts'}
        href={''}
        expanded={props.expanded}
        icon={<CommandKeyIcon className="size-4" />}
        count={undefined}
        onClick={(_, e) => {
          e.preventDefault();
          e.stopPropagation();
          showCurrentLocationShortcuts();
        }}
      />

      <KeyboardShortcutsSidePane
        isOpen={isKeyboardShortcutDocumentationOpen}
        doClose={() => setIsKeyboardShortcutDocumentationOpen(false)}
      />
    </>
  );
}

export default KeyboardShortcutLink;
